"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulkReimportMenuBodyToJSON = exports.BulkReimportMenuBodyFromJSONTyped = exports.BulkReimportMenuBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
function BulkReimportMenuBodyFromJSON(json) {
    return BulkReimportMenuBodyFromJSONTyped(json, false);
}
exports.BulkReimportMenuBodyFromJSON = BulkReimportMenuBodyFromJSON;
function BulkReimportMenuBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'businessIds': !(0, runtime_1.exists)(json, 'businessIds') ? undefined : json['businessIds'],
    };
}
exports.BulkReimportMenuBodyFromJSONTyped = BulkReimportMenuBodyFromJSONTyped;
function BulkReimportMenuBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'businessIds': value.businessIds,
    };
}
exports.BulkReimportMenuBodyToJSON = BulkReimportMenuBodyToJSON;
